/** Language and direction constants — §12. */

export const SUPPORTED_LANGUAGES = ['en', 'ar'] as const

export type Language = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: Language = 'en'

/** Languages written right-to-left. */
const RTL_LANGUAGES = new Set<Language>(['ar'])

export type Direction = 'ltr' | 'rtl'

/**
 * Direction for a language tag, region subtag and all.
 *
 * `ar-AE` and `ar-SA` are both right-to-left. i18next is configured with
 * `load: 'languageOnly'` so it normally hands us a bare `ar`, but this is also
 * called with raw `navigator.language` values, and getting `ar-SA` wrong would
 * render the whole Saudi audience left-to-right.
 */
export function directionFor(language: string): Direction {
  const base = language.split('-')[0]?.toLowerCase() ?? ''
  return RTL_LANGUAGES.has(base as Language) ? 'rtl' : 'ltr'
}

export function isSupported(language: string): language is Language {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(language)
}

/** Language names in their own language — never translated. */
export const LANGUAGE_LABELS: Record<Language, string> = {
  en: 'English',
  ar: 'العربية',
}

/**
 * Bundles are split per portal and loaded at the route boundary, so a learner
 * never downloads the organizer's strings.
 */
export const DEFAULT_NAMESPACE = 'common'
